import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 12px;
`;

export const CarouselContainer = styled.div`
  width: 100%;
  max-width: 280px; /* ahora más estrecho */
  overflow: hidden;
  position: relative;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
`;

export const CarouselTrack = styled.div`
  display: flex;
  transition: transform 0.4s ease-in-out;
  width: 100%;
`;

export const ImageWrapper = styled.div`
  min-width: 100%;
  height: 110px; /* más compacto aún */
  overflow: hidden;
  position: relative;
  border-radius: 10px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }
`;

export const Button = styled.button`
  background-color: rgba(0, 0, 0, 0.4);
  border: none;
  color: white;
  font-size: 18px;
  padding: 4px;
  border-radius: 50px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }

  &.prev {
    left: 5px;
  }

  &.next {
    right: 5px;
  }
`;
